import { DocumentsStep } from "./DocumentsStep"

export { DocumentsStep } from "./DocumentsStep"
export default DocumentsStep
